import isGlobalSettingsMailbox from 'owa-account-source-list-store/lib/utils/isGlobalSettingsMailbox';
import type { MailboxInfo } from 'owa-client-types';
import { getAccountScopeUserSettings } from 'owa-session-store';
import type { OutlookCloudPolicySettingId } from '../store/schema/OutlookCloudPolicyTypes';
import { isPoliciesEnabledForAccount } from '../utils/isPoliciesEnabledForAccount';
import { getPolicyDataBySettingId } from './getPolicyDataBySettingId';

const PRIME_BOOT_OCPS_SETTING_ID = 'OutlookCloudPolicies';

export function isOcpsPolicyEnabled(
    settingId: OutlookCloudPolicySettingId,
    mailboxInfo: MailboxInfo,
    enabledIfUndefined?: boolean
): boolean {
    if (!isPoliciesEnabledForAccount(mailboxInfo)) {
        return enabledIfUndefined ?? true;
    }

    if (isGlobalSettingsMailbox(mailboxInfo)) {
        const primeSettingsItems = getAccountScopeUserSettings(mailboxInfo)?.PrimeSettings?.Items;
        const ocpsPrimeSetting = primeSettingsItems?.find(
            (item: any) => item?.Id === PRIME_BOOT_OCPS_SETTING_ID
        );
        if (ocpsPrimeSetting) {
            const policies:
                | Array<{
                      settingId: string;
                      value: string;
                  }>
                | undefined = ocpsPrimeSetting.Value?.policies;
            const policyItem = policies?.find(p => p.settingId === settingId);

            if (policyItem) {
                return policyItem.value === '1';
            }
        }
    }

    const policyData = getPolicyDataBySettingId(mailboxInfo, settingId);

    return policyData ? policyData.value === '1' : enabledIfUndefined ?? false;
}
